<rask-div-list [data]="$safeNavigationMigration(rojningTradskikt?.tradslag)">
  <rask-list-column width="190px" header="Trädslag">
    <ng-template let-row="row">
      <rask-selector
        class="w-100 mt-0 ps-0"
        [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
        [values]="allaTradslag"
        [(ngModel)]="row.tradslagId"
        (change)="tradslagChanged($event, row.guid)"
        [viewFormatter]="viewFormatter"
        [formatter]="selectionFormatter"
        [viewSelectedFormatter]="viewFormatter"
        [exclude]="excludedTradslag(row.tradslagId)">
      </rask-selector>
    </ng-template>
  </rask-list-column>
  <rask-list-column header="Höjd (M)" width="100px">
    <ng-template let-row="row">
      <rask-input-number
        class="mt-0 ps-0"
        [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
        [(ngModel)]="row.tradhojd"
        [useDecimalProcessor]="true"
        [isNegative]="false"
        (change)="somethingChanged($event)">
      </rask-input-number>
    </ng-template>
  </rask-list-column>
  <rask-list-column header="Antal Stam" width="100px">
    <ng-template let-row="row">
      <rask-input-number
        class="mt-0 ps-0"
        [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
        [(ngModel)]="row.antalHa"
        [isDecimal]="false"
        [isNegative]="false"
        [useDecimalProcessor]="true"
        (change)="somethingChanged($event)">
      </rask-input-number>
    </ng-template>
  </rask-list-column>
  <rask-list-column width="150px">
    <ng-template let-row="row">
      <rask-action-button
        [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
        (click)="deleteTradslag(row.guid)"
        icon="far fa-trash-alt"
        negative>
        <span>
          Ta bort
        </span>
      </rask-action-button>
    </ng-template>
  </rask-list-column>
</rask-div-list>
@if (showSumRow()) {
  <div class="summarize-footer">
    <div class="row rowfooter d-table">
      <div class="d-table-cell sum-text-width">
        <span>Medel/s:a</span>
      </div>
      <div class="d-table-cell sum-antal-width">
        <span>{{medelvardeHojd}}</span>
      </div>
      <div class="d-table-cell sum-antal-width">
        <span>{{summaAntalStam}}</span>
      </div>
      <div class="d-table-cell sum-delete-width">
      </div>
    </div>
  </div>
}
<div class="row">
  <div class="col-4 pt-2">
    <rask-action-button icon="fas fa-plus" [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly" (click)="addTradslag()" class="float-start mx-0">Lägg till trädslag</rask-action-button>
  </div>
</div>
